import { render } from "./ContactTracing.vue?vue&type=template&id=2961b0c8"
import script from "./ContactTracing.vue?vue&type=script&lang=js"
export * from "./ContactTracing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__